import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Sidebar from "../../../partials/aside/Sidebar";
import helperSpinner from "../../../../helpers/spinner";
import helpersNumbers from "../../../../helpers/numbers";
import httpService from "../../../../services/httpServices/httpServices";
import typeTransaction from "../manage/typeTransaction";
import helpersTime from "../../../../helpers/time";
import TitleBar from "../../../partials/content/TitleBar";
import Pagination from "../../../partials/content/Pagination";

export default function AllTransactionCoworker() {
  const [transactionCoworker, setTransactionCoworker] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [currentTransactionID, setCurrentTransactionID] = useState(0);
  const [transactionIDSearchFilter, setTransactionIDSearchFilter] = useState();
  const [showModal, setShowModal] = useState(false);
  const [isEditReason, setIsEditReason] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  useEffect(() => {
    getAllTransactionCoworker();
  }, []);

  useEffect(() => {
    getAllTransactionCoworker();
  }, [currentPage, countItemPerPage, transactionIDSearchFilter]);

  const editReason = async () => {
    const reason = document.querySelector("#reason").value.trim();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    await sendRequestEditReason(currentTransactionID, reason);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  };

  const sendRequestEditReason = async (transactionID, reason) => {
    let headersRequest = getHeaderForRequest();
    try {
      await httpService.putRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/payment/transaction/coworker-customer/${transactionID}/edit-reason`,
        { reason: reason },
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return true;
  };

  const showReasonTransaction = () => {
    if (!currentTransactionID) {
      return;
    }
    if (transactionCoworker.length == 0) {
      return;
    }
    const transaction = transactionCoworker.filter(
      (transaction) => transaction.id == currentTransactionID
    );
    if (transaction.length == 0) {
      return;
    }
    return (
      <div>
        <p>{transaction[0].reason}</p>
        <hr />
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            await editReason();
            setIsEditReason(false);
            getAllTransactionCoworker();
          }}
          className={`${isEditReason ? "" : "d-none"}`}
        >
          <div className="py-2">
            <textarea className="form-control" rows={5} id="reason" required>
              {transaction[0].reason}
            </textarea>
          </div>
          <button
            className={`${isEditReason ? "" : "d-none"}  btn btn-success`}
          >
            اعمال
          </button>
        </form>

        <div>
          <span
            className={`${isEditReason && "d-none"} btn btn-success`}
            onClick={() => {
              setIsEditReason(true);
            }}
          >
            ویرایش متن دلیل
          </span>
        </div>
      </div>
    );
  };

  const getAllTransactionCoworker = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultGetAllTransactionCoworker = await sendGetAllTransactionCoworker(
      searchFilterQuery
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultGetAllTransactionCoworker) {
      return;
    }

    setTransactionCoworker(resultGetAllTransactionCoworker.transactions);
    setCountPage(resultGetAllTransactionCoworker.count_page);
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (transactionIDSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&id=${transactionIDSearchFilter}`;
    }

    return searchFilterQuery;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendGetAllTransactionCoworker = async (searchFilterQuery) => {
    let result;
    let headersRequest = getHeaderForRequest();
    try {
      result = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/payment/transaction/coworker-customer?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return result.data.data;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const generateTransactionCoworker = () => {
    return (
      <>
        <div className="pt-2">
          <div className="alert alert-warning ">
            <p className="text-justify">
              <i className="fa fa-info pl-2"></i>
              توجه داشته باشید :{" "}
            </p>
            <ul className="pr-3">
              <li>
                <p className="text-justify">
                  در این بخش شما میتوانید موجودی حساب کاربران خود را افزایش یا
                  کاهش دهید.
                </p>
              </li>
            </ul>
          </div>
          <div>
            <Link
              to="/finance/coworker/add-transaction"
              className="btn btn-success"
            >
              <span className="d-flex align-items-center">
                <i className="fa fa-plus"></i>
                <span className="pr-2">تراکنش جدید</span>
              </span>
            </Link>
          </div>
          <br />
          <div class="container-fluid pb-2">
            <div class="row border border-1 rounded py-2">
              <div class="col-12 col-md-4">
                <div>
                  <label>جستجو در شماره تراکنش</label>
                </div>
                <div>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="شماره تراکنش را در اینجا وارد کنید "
                    onWheel={(event) => event.currentTarget.blur()}
                    onKeyUp={(e) =>
                      setTransactionIDSearchFilter(e.target.value)
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="table-responsive">
            <table className="table table-hilite tbl-td-white-space m-0">
              <thead>
                <tr>
                  <td>#</td>
                  <td>شماره تراکنش</td>
                  <td>شماره کاربر</td>
                  <td>نام کاربر</td>
                  <td>مبلغ(تراکنش)</td>
                  <td>عملیات</td>
                  <td>تاریخ درج</td>
                  <td>دلیل</td>
                </tr>
              </thead>
              <tbody>
                {transactionCoworker.map((transaction, index) => {
                  return (
                    <tr>
                      <td>{helpersNumbers.toPersianNum(index + 1)}</td>
                      <td>{helpersNumbers.toPersianNum(transaction.id)}</td>
                      <td>
                        {helpersNumbers.toPersianNum(transaction.user_id)}
                      </td>
                      <td>{helpersNumbers.toPersianNum(transaction.name)}</td>
                      <td>
                        <span className="letter-spacing-finance-number">
                          {helpersNumbers.toPersianNum(
                            helpersNumbers.toFormatFinanceNumber(
                              transaction.amount
                            )
                          )}
                        </span>
                      </td>
                      <td>{generateTagOperation(transaction.operate)}</td>
                      <td>
                        {helpersNumbers.toPersianNum(transaction.created_at)}
                      </td>
                      <td>
                        <span
                          className="btn btn-info"
                          onClick={(e) => {
                            setCurrentTransactionID(transaction.id);
                            handleShowModal();
                          }}
                        >
                          <i className="fa fa-eye"></i>
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  const generateTagOperation = (operate) => {
    let statusTagOperate = <></>;
    switch (operate) {
      case typeTransaction.typeOperateTransaction.ADD:
        statusTagOperate = (
          <span className="badge badge-success">
            {typeTransaction.typeOperateTransactionString()[operate]}
          </span>
        );
        break;
      case typeTransaction.typeOperateTransaction.SUBTRACT:
        statusTagOperate = (
          <span className="badge badge-danger">
            {typeTransaction.typeOperateTransactionString()[operate]}
          </span>
        );
        break;
    }
    return statusTagOperate;
  };

  const generateCustomerDoseNotHaveTransaction = () => {
    return (
      <div className="d-flex flex-column flex-md-row">
        <div className="text-center text-md-right">
          <img
            class="img-fluid"
            src="/assets/img/do-not-have-transaction.svg"
          />
        </div>
        <div className="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
          <p className="text-justify">
            در این بخش شما میتوانید موجودی حساب کاربران خود را افزایش یا کاهش
            دهید.
          </p>
          <p className="text-justify">
            شما تاکنون انتقال اعتبار به کاربران خود نداشته اید و تاریخچه انتقال
            اعتبار شما خالی است.
          </p>
          <div>
            <Link
              to="/finance/coworker/add-transaction"
              className="btn btn-success"
            >
              <span className="d-flex align-items-center">
                <i className="fa fa-plus"></i>
                <span className="pr-2">تراکنش جدید</span>
              </span>
            </Link>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar
        openItem="coworker-customer-finance"
        activeItem="all-transaction-coworker-customer"
      />

      <div className="content-wrapper">
        <TitleBar title="انتقال اعتبار" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body" id="list-customer">
              {transactionCoworker.length == 0 &&
              transactionIDSearchFilter == null
                ? generateCustomerDoseNotHaveTransaction()
                : generateTransactionCoworker()}
            </div>
          </div>
        </section>
      </div>
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>دلیل انجام تراکنش</Modal.Title>
        </Modal.Header>
        <Modal.Body>{showReasonTransaction()}</Modal.Body>
        <Modal.Footer>
          <span className="btn btn-danger" onClick={handleCloseModal}>
            خروج
          </span>
        </Modal.Footer>
      </Modal>
    </>
  );
}
